import {
  AaaGameInformationXboxNetworkDataType,
  GameInformationXboxNetworkDataType,
} from "../../../../../../models/forms";
import { XboxNetworkAddOns } from "../../../../../../models/xboxNetworkAddOns";
import { XboxNetworkFeatures } from "../../../../../../models/xboxNetworkFeatures";
import { EntityName } from "../../../../dataService";
import { YesNoChoice } from "../../../../dataService/models/staticOptions";
import { ContentValidationCrmData } from "../../../models/contentValidation";
import { CrmEntityManager } from "../../../utils/CrmEntityManager";
import { mapToStringFormsValue } from "../../utils/mapToStringFormsValue";

export const mapXboxNetworkToForms = (
  gameConcept: CrmEntityManager<EntityName.gaming_gameconcept>,
  contentValidation: ContentValidationCrmData
): GameInformationXboxNetworkDataType => {
  const result: Partial<GameInformationXboxNetworkDataType> = {};
  mapCommonXboxNetworkToForms(gameConcept, result);
  result.isStarted = !!contentValidation.isStarted.xboxNetwork;
  return result as GameInformationXboxNetworkDataType;
};

// These are common parameters shared between ID@Xbox and AAA game concepts.
// Exclusive parameters should be set outside of this shared mapper.
export const mapCommonXboxNetworkToForms = (
  gameConcept: CrmEntityManager<EntityName.gaming_gameconcept>,
  result:
    | Partial<GameInformationXboxNetworkDataType>
    | Partial<AaaGameInformationXboxNetworkDataType>
) => {
  result.addOns = [
    gameConcept.get("ggp_dlcpacks") === YesNoChoice.yes ? XboxNetworkAddOns.dlcPacks : "",
    gameConcept.get("ggp_durables") === YesNoChoice.yes ? XboxNetworkAddOns.durables : "",
    gameConcept.get("ggp_freeaddoncontent") === YesNoChoice.yes
      ? XboxNetworkAddOns.freeAddOnContent
      : "",
    gameConcept.get("gaming_consumables") === YesNoChoice.yes ? XboxNetworkAddOns.consumables : "",
    gameConcept.get("gaming_ingamesubscriptions") === YesNoChoice.yes
      ? XboxNetworkAddOns.inGameSubscriptions
      : "",
  ].filter(x => x !== "");

  result.xboxNetworkFeatures = [
    gameConcept.get("ggp_crossownership") === YesNoChoice.yes
      ? XboxNetworkFeatures.crossOwnership
      : "",
    gameConcept.get("ggp_crossprogression") === YesNoChoice.yes
      ? XboxNetworkFeatures.crossProgression
      : "",
    gameConcept.get("ggp_crosssave") === YesNoChoice.yes ? XboxNetworkFeatures.crossSave : "",
    gameConcept.get("ggp_sharedachievements") === YesNoChoice.yes
      ? XboxNetworkFeatures.sharedAchievements
      : "",
    gameConcept.get("ggp_xboxplayanywhere") === YesNoChoice.yes
      ? XboxNetworkFeatures.xboxPlayAnywhere
      : "",
    gameConcept.get("gaming_smartdeliveryxboxoneandxboxseriesx") === YesNoChoice.yes
      ? XboxNetworkFeatures.smartDelivery
      : "",
  ].filter(x => x !== "");

  result.additionalContent = mapToStringFormsValue(
    gameConcept.get("ggp_addoncontentplandetails_ml")
  );
};
